// The R10 artboard — one document page (1240×1754), with the paper wash, film
// grain, and running foot every section sits inside. Section content is passed as
// children; `sectionMark` is the lower-right page marker (e.g. "i · cover").
// `screenLabel` / `run` carry the Field Mapping Spec `data-screen-label` / `data-run`
// provenance markers; the footer separators use `.foot-faint` (muted) per canon F4.

export default function Artboard({ children, sectionMark, screenLabel, run }) {
  return (
    <div className="artboard" data-screen-label={screenLabel} data-run={run}>
      <div className="ab-paper" />
      {children}
      <div className="ab-grain" />
      <div className="ab-foot">
        <span data-field="footer_left">
          <span className="foot-em">life map</span>
          <span className="foot-faint"> · </span>
          <span className="foot-amber">first reading</span>
        </span>
        <span className="foot-page" data-field="footer_right">{sectionMark}</span>
      </div>
    </div>
  );
}
